module.exports = __webpack_public_path__ + "a5a04d1ad23d46dbcd0448bcf3916bb7.pdf";